import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';
import { isMyDealerServiceAvailable } from 'src/feature-app';

export const getMapaTitle = (formName?: string, short?: boolean) => {
	if (isMyDealerServiceAvailable()) {
		return null;
	} else if (formName === 'testDrive') {
		return (
			<Text>
				{' '}
				<Text bold>¿Dónde</Text> prefieres{' '}
				<span style={{ whiteSpace: 'nowrap' }}>
					probarlo?
					<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
				</span>
			</Text>
		);
	} else if (formName === 'venta' || formName === 'vo') {
		return (
			<Text>
				{' '}
				<Text bold>¿A dónde</Text> quieres{' '}
				<span style={{ whiteSpace: 'nowrap' }}>
					ir?<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
				</span>
			</Text>
		);
	} else {
		return (
			<>
				<Text>
					{' '}
					<Text bold>¿Qué experto</Text> quieres que se{' '}
					<span style={{ whiteSpace: 'nowrap' }}>
						encargue?
						<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
					</span>
				</Text>
				{formName === 'presupuesto' && !short ? (
					<div>
						<Text appearance={TokenTextAppearance.copy200}>
							Los encargados de elaborar un presupuesto son los
							asesores de la red de Concesionarios Oficial
							Volkswagen. Elige uno y le enviaremos tu petición
							para que te haga una propuesta a medida.
						</Text>
					</div>
				) : null}
			</>
		);
	}
};
